var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4572 15.4843L12.4111 11.2762C13.4514 10.0396 14.0214 8.48359 14.0214 6.86374C14.0214 3.07913 10.9423 0 7.15769 0C3.37308 0 0.293945 3.07913 0.293945 6.86374C0.293945 10.6484 3.37308 13.7275 7.15769 13.7275C8.57848 13.7275 9.93243 13.299 11.09 12.4854L15.1668 16.7255C15.3372 16.9024 15.5664 17 15.812 17C16.0444 17 16.265 16.9114 16.4324 16.7502C16.7881 16.4079 16.7995 15.8403 16.4572 15.4843ZM7.15769 1.79054C9.95511 1.79054 12.2309 4.06632 12.2309 6.86374C12.2309 9.66117 9.95511 11.9369 7.15769 11.9369C4.36027 11.9369 2.08449 9.66117 2.08449 6.86374C2.08449 4.06632 4.36027 1.79054 7.15769 1.79054Z",
    fill: "#603888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b8fd8fdee765165dc219563523412e21.svg";
export { ForwardRef as ReactComponent };